<template>
  <div class="carousel">
    <div class="swiper-container">  
        <div class="swiper-wrapper"> 
            <div class="swiper-slide">
                <div class="sectionFirst">
                    <div class="middle_wmq">
                        <img src="../assets/weimaqi.png" alt="" class="weimaqi">
                        <p class="title">支持多个支付平台　 | 　安装简易功能强大　 | 　后台实时把控数据</p>
                        <span class="bug" @click="contactBug()">联系购买</span>
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="sectionTwo">
                    <img src="../assets/pay_case.png" alt="" class="pay_case">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="sectionThree">
                    <img src="../assets/patent.png" alt="" class="patent">
                    <img src="../assets/letters_patent.png" alt="" class="letters_patent">
                </div>
            </div>
        </div>
    </div>
    <!-- 底部状态 -->
    <div class="button_line" :class="current">
        <span v-for="(item,index) in 3" :class="{active:cur==index}" @click="change(index)" :key="index"></span>
    </div>
    <!-- 侧边状态 -->
    <!-- <div class="sider" :class="current"> -->
        <div class="sider_item" :class="current">
            <p class="num_one" v-text="indexPage"></p>
            <span class="sider_line"></span>
            <img class="sider_left" @click="clickPrev()" :src="page === 2 ? white_left : black_left" alt="">
            <span class="sider_line"></span>
            <p class="num_two">03</p>
        </div>
        <div class="sider_item" :class="current">
            <p class="num_one" v-text="indexPage"></p>
            <span class="sider_line"></span>
            <img class="sider_right" @click="clickNext()" :src="page === 2 ? white_right : black_right" alt="">
            <span class="sider_line"></span>
            <p class="num_two">03</p>
        </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name:"First",
  data(){
      return{
          mySwiper: '',
          current: 'd1',
          cur: 0,
          indexPage: '01',
          page: 1,
          white_left: require('../assets/white_left.png'),
          white_right: require('../assets/white_right.png'),
          black_left: require('../assets/black_left.png'),
          black_right: require('../assets/black_right.png')
      }
  },
  mounted () {
      var that = this;
      this.mySwiper = new Swiper('.swiper-container',{
        slidePerView:1,
        // mousewheel:true,
        autoHeight: true,
        speed:500,
        loop:true,
        resistanceRatio:0,
        autoplay: {
            delay:5000,
            disableOnInteraction:false,
        },
        // pagination:{
        //     el:'.swiper-pagination',
        //     clickable: true             
        // },
        on: {
            slideChangeTransitionStart: function(){
                that.indexPage = '0' +(this.realIndex +1);
                that.current = 'd' +(this.realIndex +1);
                that.cur = this.realIndex;
                that.page = this.realIndex +1;
           },                
        },
    });
  },
  methods: {
      change(index){
        this.cur = index;
        this.indexPage = '0' + (index+1);
        this.current = 'd' + (index+1);
        this.page = index +1;
        this.mySwiper.slideToLoop(index, 500, false);
    },
    clickPrev () {
        this.mySwiper.slidePrev();
    },
    clickNext () {
        this.mySwiper.slideNext();
    },
    // 联系购买
    contactBug () {
        this.$emit('contactBug')
    }
  }
}
</script>

 <style scoped>
 .carousel {
    width: 100%;
    height: 650px;
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    margin-top: 100px;
 }
 .sectionFirst{
    width: 100%;
    height: 650px;
    background: url(../assets/poster_one.png) no-repeat;
    background-size: 100% 100%;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
 }
 .middle_wmq {
    width: 820px;
    height: 334px;
    background: url(../assets/IMG.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
 }
 .middle_wmq .weimaqi {
    width: 454px;
	height: 70px;
 }
  .middle_wmq .weimaqi>img {
      width: 100%;
  }
    .middle_wmq .title {
       font-size: 20px;
       margin: 28px 0px 34px 0px;
   }
   .middle_wmq .bug {
        width: 160px;
        height: 54px;
        line-height: 54px;
        background-color: #016bff;
        display: block;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
   }

   /* 轮播第二页 */
   .sectionTwo {
        width: 100%;
        height: 650px;
        background: url(../assets/poster_two.png) no-repeat;
        background-size: 100% 100%;
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;
   }
   .sectionTwo .pay_case {
        width: 478px;
	    height: 220px;
   }

/* 轮播第三页 */
   .sectionThree {
        width: 100%;
        height: 650px;
        background: url(../assets/poster_three.png) no-repeat;
        background-size: 100% 100%;
        background-position: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
   }
   .sectionThree .patent {
       width: 646px;
        height: 116px;
        margin-bottom: 22px;
        display: inline-block;
   }
   .sectionThree .letters_patent {
       width: 720px;
	    height: 255px;
   }
   .sectionThree .patent>img, .sectionThree .letters_patent>img {
       width: 100%;
   }

   .button_line {
       width: 100%;
       z-index: 1;
       text-align: center;
       position: absolute;
       bottom: 46px;
   }
   .button_line>span {
        width: 58px;
        height: 8px;
        background-color: #333;
        display: inline-block;
        margin: 0px 5px;
        cursor: pointer;
   }
   .button_line>span.active, .button_line.d2>span.active {
       background-color: #016bff;
   }
   .button_line.d2>span {
       background-color: #fff;
   }
   /* 左右侧俩边状态 */
   .sider_item {
        width: 44px;
        height: 227px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
   }
   .carousel .sider_item:nth-child(3) {
        position: absolute;
        bottom: 210px;
        z-index: 1;
        left: 0;
        margin-left: 100px;
   }
   .carousel .sider_item:nth-child(4) {
        position: absolute;
        bottom: 210px;
        z-index: 1;
        right: 0;
        margin-right: 100px;
   }
   .sider_item>p {
       font-size: 14px;
       color: #333;
   }
   .sider_item.d2>p {
       color: #fff;
   }
   .sider_item>.num_one {
       margin-bottom: 10px
   }
   .sider_item>.num_two {
       margin-top: 10px
   }
   .sider_item>.sider_line {
       width: 2px;
       height: 67px;
       background-color: #333;
   }
   .sider_item.d2>.sider_line {
       background-color: #fff;
   }
   .sider_item>.sider_left {
        width: 44px;
        height: 10px;
        cursor: pointer;
        margin-bottom: 15px;
        margin-top: 10px;
   }
   .sider_item>.sider_right {
        width: 44px;
        height: 10px;
        cursor: pointer;
        margin-bottom: 15px;
        margin-top: 10px;
   }
   .sider_item.d2>.sider_left, .sider_item.d2>.sider_right {
       color: #fff;
   }
 </style>





// WEBPACK FOOTER //
// src/components/First.vue